<template>
  <div class="about">
    <my-header />

    <div class="imgBar">
      <a
        href="javascript:void(0)"
        @click="toView('/simple?parentId=&catalogName=门把手锁', 'simple')"
      >
        <img class="img-responsive" src="../assets/01.jpg" />
      </a>
      <a
        href="javascript:void(0)"
        @click="toView('/applicationTwo?go=applicationTwo', 'applicationTwo')"
      >
        <img target="_balck" class="img-responsive" src="../assets/02.jpg" />
      </a>

      <img class="img-responsive" src="../assets/03.jpg" />
      <div class="choice">
        <p class="p1">设计或选择属于自己的符合您风格的产品</p>
        <p class="p2">
          我们全新的门五金作曲家可让您混合搭配任何我们的锁眼盖，<br />
          把手和饰面，从而打造出满足您需求的独特作品。
        </p>
        <p class="p3">
          <a herf="javascript:void(0)">DIY定制</a>
          <br />

          <a herf="javascript:void(0)">配套合适的产品</a>
        </p>
      </div>
      <img class="img-responsive" src="../assets/04.jpg" />
      <img class="img-responsive" src="../assets/05.jpg" />
      <img class="img-responsive" src="../assets/06.jpg" />
      <div class="support">
        <p class="p1">我们支持我们的产品</p>
        <p class="p2">
          高技能的工匠在制作我们系列中的每件作品，以实现罕见的美感和持久的风格，让您看到并感受到与众不同。
        </p>
        <p>
          信誉就是一切。因此，我们站在每一个产品的后面，<br />
          以确保它超出您的期望
        </p>

        <p class="p3">
          <a
            href="javascript:void(0)"
            @click="toView('/aboutUs?go=aboutUs', 'aboutUs')"
            >了解我们</a
          >
          <!-- <router-link to="/aboutUs">了解我们</router-link> -->
          <!-- <a herf="javascript:void(0)"></a> -->
          <br />

          <a
            href="javascript:void(0)"
            @click="toView('/newProduct?go=newProduct', 'newProduct')"
            >新品</a
          >
          <a herf="javascript:void(0)"></a>
        </p>
      </div>
    </div>

    <my-footer />
  </div>
</template>

<script>
import myHeader from "@/views/myHeader.vue";
import myFooter from "@/views/myFooter.vue";
// import navBar from "@/views/navBar.vue"

export default {
  components: {
    myHeader,
    myFooter
    // navBar
  },
  data() {
    return {};
  },
  methods: {
    toView(path, goId) {
      if (this.$route.fullPath != path) {
        this.$router.push(path);
      } else {
        document.querySelector("#" + goId).scrollIntoView(true);
      }
    }
  }
};
</script>

<style>
.imgBar {
  padding-bottom: 65px;
}

.imgBar img {
  width: 100%;
  display: block;
}

.choice {
  width: 100%;
  margin: 0 auto;
  padding: 45px 15px;
  color: #595757;
  line-height: 32px;
  display: none;
}

.choice .p1 {
  font-size: 25px;
  font-weight: lighter;
}

.choice .p2 {
  font-size: 16px;
  letter-spacing: 0.5px;
}

.choice .p3 {
  margin-top: 30px;
}

.choice .p3 a {
  color: #ccb356;
  text-decoration: none;
}

.support {
  width: 100%;
  margin: 0 auto;
  padding: 45px 15px;
  color: #595757;
  line-height: 32px;
  display: none;
}

.support .p1 {
  font-size: 25px;
  font-weight: lighter;
}

.support .p2 {
  font-size: 16px;
  margin-top: 30px;
}

.support .p3 {
  margin-top: 30px;
}

.support .p3 a {
  color: #ccb356;
  text-decoration: none;
}

/* 媒体查询 */
@media screen and (max-width: 850px) {
  .choice {
    display: block !important;
  }

  .support {
    display: block !important;
  }
}
</style>
